import { ComponentsOverrides } from '@mui/material/styles/overrides';
import { tabClasses, tabsClasses } from '@mui/material';
import palette from '../theme/palette';
import { Theme } from '@mui/material/styles';

const styleOverrides: ComponentsOverrides['MuiTabs'] = {
  root: {
    minHeight: 0,
    borderBottom: `1px solid ${palette.divider}`,
    position: 'relative',

    [`& .${tabsClasses.scrollButtons}`]: {
      padding: 0,
      width: 'auto',
      alignItems: 'start',
      position: 'absolute',
      opacity: 1,
      zIndex: 1000,
      borderRadius: '1000px',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    [`& .${tabsClasses.scrollButtons}.Mui-disabled`]: {
      opacity: 0,
    },
    [`& .${tabsClasses.scrollButtons}:first-of-type`]: {
      left: 0,
      justifyContent: 'start',
      background: palette.background.default,
    },
    [`& .${tabsClasses.scrollButtons}:last-child`]: {
      right: 0,
      justifyContent: 'end',
      background: palette.background.default,
    },
  },
  vertical: ({ theme }) => ({
    borderBottom: 'none',

    [`& .${tabClasses.root}`]: {
      padding: `${(theme as Theme).spacing(1)} ${(theme as Theme).spacing(1.5)}`,
    },
  }),
  indicator: {
    left: 0,
    borderRadius: '2px',
  },
};

export default styleOverrides;
